import { VectorGridOptions } from 'leaflet'
import { useContext } from 'react'
import { buildVectorTileLayerDefaultOptions } from '../utils'
import { VectorGrid } from './VectorGrid'
import LayersContext from '../../../contexts/Layers'
import { forestGroupTitles } from '../Controls/LayersControl/SideMenu'
import { ForestGroupPopup } from '../Popups/ForestGroupPopup'
import { useLayerPopupHandler } from '../hooks'
import { api } from '../../../config'

const layerSource = 'forest_groups'
const options: VectorGridOptions = {
  zIndex: 2,
  vectorTileLayerStyles: {
    [layerSource]: (properties) =>
      Object.values(
        buildVectorTileLayerDefaultOptions(properties.title, layerSource).vectorTileLayerStyles
      )[0],
  },
}

export const ForestGroupsLayer = () => {
  const { selected } = useContext(LayersContext)
  const selectedTitles = forestGroupTitles
    .filter((title) => selected.includes(title))
    .map((title) => `title[]=${title}`)
    .join('&')

  const [popupProps, handleClick] = useLayerPopupHandler(!!selectedTitles)

  return selectedTitles ? (
    <>
      <VectorGrid
        url={`${api.host}/vector_tiles/${layerSource}/{z}/{x}/{y}.pbf?${selectedTitles}`}
        options={options}
        onClick={handleClick}
      />
      {popupProps ? <ForestGroupPopup {...popupProps} /> : null}
    </>
  ) : null
}
